import { apis } from 'utils/lib/apis';
import { logToSentry } from "utils/networkErrorUtils";
import * as PermissionsActions from './actions';

export const handleGetUserPermissions = (userId) => async (dispatch) => {
    dispatch(PermissionsActions.getUserPermissions());
    try {
        const response = await apis.get('permissionsRDS', `/user-permissions/${userId}`);
        if (response && response.success) {
            const permissionsData = {
                ...response.data,
                user_id: userId
            };
            dispatch(PermissionsActions.getUserPermissionsSuccess(permissionsData));
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error getting user permissions',
            error,
            module: 'PERMISSIONS',
            operation: 'GET_USER_PERMISSIONS'
        });
        dispatch(PermissionsActions.getUserPermissionsFail(error));
        return { success: false, error };
    }
};

export const handleUpdateUserPermissions = (userId, permissions) => async (dispatch) => {
    dispatch(PermissionsActions.updateUserPermissions());
    try {
        const response = await apis.put('permissionsRDS', `/user-permissions/${userId}`, {
            body: permissions
        });
        if (response && response.success) {
            dispatch(PermissionsActions.updateUserPermissionsSuccess(response.data));
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error updating user permissions',
            error,
            module: 'PERMISSIONS',
            operation: 'UPDATE_USER_PERMISSIONS'
        });
        dispatch(PermissionsActions.updateUserPermissionsFail(error));
        return { success: false, error };
    }
};

export const handleListActivityPermissions = () => async (dispatch) => {
    dispatch(PermissionsActions.listActivityPermissions());
    try {
        const response = await apis.get('permissionsRDS', '/activity-permissions');
        if (response && response.success) {
            dispatch(PermissionsActions.listActivityPermissionsSuccess(response.data));
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error listing activity permissions',
            error,
            module: 'PERMISSIONS',
            operation: 'LIST_ACTIVITY_PERMISSIONS'
        });
        dispatch(PermissionsActions.listActivityPermissionsFail(error));
        return { success: false, error };
    }
};

export const handleUpdateActivityPermissions = (permissions) => async (dispatch) => {
    dispatch(PermissionsActions.updateActivityPermissions());
    try {
        const response = await apis.put('permissionsRDS', '/activity-permissions', {
            body: permissions
        });
        if (response && response.success) {
            dispatch(PermissionsActions.updateActivityPermissionsSuccess(response.data));
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error updating activity permissions',
            error,
            module: 'PERMISSIONS',
            operation: 'UPDATE_ACTIVITY_PERMISSIONS'
        });
        dispatch(PermissionsActions.updateActivityPermissionsFail(error));
        return { success: false, error };
    }
};

export const handleUpdateUser2FA = (userId, enabled) => async (dispatch) => {
    dispatch(PermissionsActions.updateUser2FA());
    try {
        const response = await apis.put('permissionsRDS', `/user-2fa/${userId}`, {
            body: { enabled }
        });
        if (response && response.success) {
            dispatch(PermissionsActions.updateUser2FASuccess({ userId, enabled }));
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error updating user 2FA',
            error,
            module: 'PERMISSIONS',
            operation: 'UPDATE_USER_2FA'
        });
        dispatch(PermissionsActions.updateUser2FAFail(error));
        return { success: false, error };
    }
};

export const handleSend2FACode = (userId, email, username) => async (dispatch) => {
    try {
        const response = await apis.post('permissionsRDS', '/user-2fa/send-code', {
            body: { userId, email, username }
        });
        if (response && response.success) {
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error sending 2FA code',
            error,
            module: 'PERMISSIONS',
            operation: 'SEND_2FA_CODE'
        });
        return { success: false, error };
    }
};

export const handleVerify2FACode = (userId, code) => async (dispatch) => {
    try {
        const response = await apis.post('permissionsRDS', '/user-2fa/verify-code', {
            body: { userId, code }
        });
        if (response && response.success) {
            return { success: true, data: response.data };
        }
        return { success: false, error: response };
    } catch (error) {
        logToSentry({
            message: 'Error verifying 2FA code',
            error,
            module: 'PERMISSIONS',
            operation: 'VERIFY_2FA_CODE'
        });
        return { success: false, error };
    }
};
